import { TagItem } from '@aibees/elephant/components/see-all-popup';
import NAICS from '@aibees/elephant/constants/naics.json';
import { TextEllipsis } from '@aibees/shared/components';
import { HighlightableContent } from '@aibees/shared/features';
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

const naicsLookup = new Map<string, (typeof NAICS)[number]>();
for (const naics of NAICS) {
  naicsLookup.set(naics.id, naics);
}

export function useNaicsTags(naicsCodes: string[] | null | undefined) {
  return useMemo(() => {
    if (!naicsCodes) return null;

    return naicsCodes
      .filter((naicsCode) => naicsLookup.has(naicsCode))
      .map((naicsCode) => {
        const naicsEntry = naicsLookup.get(naicsCode) as (typeof NAICS)[number];
        return {
          label: naicsEntry.value,

          customLabel: (
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              gap={0.5}
            >
              <HighlightableContent
                content={naicsEntry.label}
                variant="body4"
                color="primary.600"
                fontWeight={700}
              />

              <Typography variant="body4">|</Typography>

              <TextEllipsis
                value={naicsEntry.metadata.subtitle}
                variant="body4"
              />
            </Box>
          ),
        } as TagItem;
      });
  }, [naicsCodes]);
}
